const useGetUuidEmployeurOuTiersFromUrl = () => {
  const locationSearch = new URLSearchParams(location.search);
  let uuidEmployeurParam = locationSearch.get("uuidEmployeur");

  if (!uuidEmployeurParam) {
    const noTiersParam = locationSearch.get("noTiers");
    if(noTiersParam) {
      uuidEmployeurParam = noTiersParam;
    }
  }

  return uuidEmployeurParam;
};

export default useGetUuidEmployeurOuTiersFromUrl;
